var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteGreyIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.5a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-8-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 9v-6h-2v6h2Z",
    fill: "#B0B6BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteGreyIco);
export default __webpack_public_path__ + "static/media/note_grey_ico.2a0880f48e297a834d5629c204100d82.svg";
export { ForwardRef as ReactComponent };